import { createNestedCrudService } from './createCrudService';

// ---------------------------------------------------------------------------
// Types
// ---------------------------------------------------------------------------

export interface ErpErrorMapping {
  id: string;
  erp_registry_id: string;
  slug: string;
  priority: number;
  match_type:
    | 'http_status'
    | 'http_status_range'
    | 'error_code'
    | 'error_message'
    | 'body_contains'
    | 'composite';
  match_config: Record<string, unknown>;
  origami_error_code: string;
  origami_error_message: string;
  http_status: number | null;
  is_retryable: boolean;
  log_level: 'debug' | 'info' | 'warning' | 'error' | 'critical';
  created_at: string;
  updated_at: string;
}

export interface CreateErpErrorMappingPayload {
  slug: string;
  priority: number;
  match_type: ErpErrorMapping['match_type'];
  match_config: Record<string, unknown>;
  origami_error_code: string;
  origami_error_message: string;
  http_status?: number | null;
  is_retryable?: boolean;
  log_level?: ErpErrorMapping['log_level'];
}

export interface UpdateErpErrorMappingPayload {
  slug?: string;
  priority?: number;
  match_type?: ErpErrorMapping['match_type'];
  match_config?: Record<string, unknown>;
  origami_error_code?: string;
  origami_error_message?: string;
  http_status?: number | null;
  is_retryable?: boolean;
  log_level?: ErpErrorMapping['log_level'];
}

// ---------------------------------------------------------------------------
// Service
// ---------------------------------------------------------------------------

export const erpErrorMappingsService = createNestedCrudService<
  ErpErrorMapping,
  CreateErpErrorMappingPayload,
  UpdateErpErrorMappingPayload
>((registryId) => `/admin/erp/registries/${registryId}/error-mappings`);
